import { createContext, useCallback, useContext, useState } from "react";
import { LeadModal } from "../components/LeadModal";
import { track } from "../lib/api";

const LeadModalContext = createContext({ openLeadForm: () => {} });

export function LeadModalProvider({ children }) {
  const [state, setState] = useState({ open: false, source: "unknown" });

  const openLeadForm = useCallback((source = "unknown", cta = "book_strategy_call") => {
    track("cta_click", { cta, source });
    setState({ open: true, source });
  }, []);

  const close = useCallback(() => setState((s) => ({ ...s, open: false })), []);

  return (
    <LeadModalContext.Provider value={{ openLeadForm }}>
      {children}
      <LeadModal open={state.open} source={state.source} onClose={close} />
    </LeadModalContext.Provider>
  );
}

export const useLeadModal = () => useContext(LeadModalContext);
